/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElForm as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { apiGetPlayerInfo } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  setup(__props, {
    expose
  }) {
    const playId = ref();
    const dialogVisible = ref(false);
    const playerInfo = ref();
    const handleClose = () => {
      dialogVisible.value = false;
    };
    const getPlayerInfo = async () => {
      const res = await apiGetPlayerInfo({
        id: playId.value
      });
      if (res.code === 0) {
        playerInfo.value = res.data;
      }
    };
    const show = payload => {
      dialogVisible.value = true;
      if (payload.data) {
        playId.value = payload.data.id;
        getPlayerInfo();
      }
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_form = __unplugin_components_1;
      const _component_el_dialog = __unplugin_components_2;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dialogVisible.value = $event),
        title: "玩家详细信息",
        width: "600px",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-width": "120px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "角色ID："
          }, {
            default: _withCtx(() => {
              var _playerInfo$value;
              return [_createElementVNode("span", null, _toDisplayString((_playerInfo$value = playerInfo.value) === null || _playerInfo$value === void 0 ? void 0 : _playerInfo$value.role_id), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "角色昵称："
          }, {
            default: _withCtx(() => {
              var _playerInfo$value2;
              return [_createElementVNode("span", null, _toDisplayString((_playerInfo$value2 = playerInfo.value) === null || _playerInfo$value2 === void 0 ? void 0 : _playerInfo$value2.nickname), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "区服ID："
          }, {
            default: _withCtx(() => {
              var _playerInfo$value3;
              return [_createElementVNode("span", null, _toDisplayString((_playerInfo$value3 = playerInfo.value) === null || _playerInfo$value3 === void 0 ? void 0 : _playerInfo$value3.server_id), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "所属平台："
          }, {
            default: _withCtx(() => {
              var _playerInfo$value4;
              return [_createElementVNode("span", null, _toDisplayString((_playerInfo$value4 = playerInfo.value) === null || _playerInfo$value4 === void 0 ? void 0 : _playerInfo$value4.platform), 1)];
            }),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});